'use client';

import React from 'react';

import { ColumnContainer, Label } from '@components/Common';
import { TextGroup } from '@components/TextGroups';

interface OnboardingStepProps {
  stepLabel: string;
  title: string;
  description: string;
  children: React.ReactNode;
}

export const OnboardingStep: React.FC<OnboardingStepProps> = ({
  stepLabel,
  title,
  description,
  children,
}) => {
  return (
    <>
      <ColumnContainer>
        <Label>{stepLabel}</Label>
        <TextGroup header={title} paragraph={description} />
      </ColumnContainer>
      {children}
    </>
  );
};